import React, { ReactNode } from 'react';
import { Button, DialogTitle, Stack, useTheme } from '@mui/material';

import XBigIcon from '@/assets/icons/x-big.svg?react';

const CommonDialogTitle = ({ children, onClose }: { children: ReactNode; onClose?: () => void }) => {
  const { spacing, palette } = useTheme();

  return (
    <DialogTitle
      component={Stack}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      bgcolor="background.default"
      sx={{
        p: spacing(1.5, 2, 2.25)
      }}
    >
      {children}
      <Button
        disableRipple
        variant="text-icon"
        type="button"
        sx={{
          color: palette.text.primary
        }}
        onClick={onClose}
      >
        <XBigIcon width={20} height={20} />
      </Button>
    </DialogTitle>
  );
};

export default CommonDialogTitle;
